module.exports = __webpack_public_path__ + "media/images/loghi/icon_tickets-943ea55cb823ef7bbd38ff5caef950d1.svg";